import { openLobbyScreen, startKnocking } from 'jitsi/lobby/actions.any';
import { setPrejoinPageVisibility } from 'jitsi/prejoin/actions.web';
import { getLocalParticipant, } from 'jitsi/base/participants/functions';
export const loadHidePreMeetingPageOptions = (state, dispatch) => {
    const { hide_pre_meeting_page: hidePage, enable_knocking: isKnockingEnabled } = window.APP?.room?.conference_options || {};
    const localParticipant = getLocalParticipant(state);
    const participantDoesntHaveName = !localParticipant?.displayName && !localParticipant?.name;
    const isKnockingActive = isKnockingEnabled && !config.iAmRecorder;
    if (window.APP.isModerator) {
        if (hidePage)
            dispatch(setPrejoinPageVisibility(false));
    }
    else {
        if (isKnockingActive && (!hidePage || participantDoesntHaveName))
            dispatch(openLobbyScreen());
        else if (hidePage && isKnockingActive)
            dispatch(startKnocking());
        else if (hidePage)
            dispatch(setPrejoinPageVisibility(false));
    }
};
